import { render, staticRenderFns } from "./reportSet.vue?vue&type=template&id=48a87c2f&scoped=true"
import script from "./reportSet.vue?vue&type=script&lang=ts"
export * from "./reportSet.vue?vue&type=script&lang=ts"
import style0 from "./reportSet.vue?vue&type=style&index=0&id=48a87c2f&prod&lang=scss&scoped=true"
import style1 from "./reportSet.vue?vue&type=style&index=1&id=48a87c2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a87c2f",
  null
  
)

export default component.exports